import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { UrlProvider } from "../../../../../api/UrlProvider";
import config from "../../../../../config";
import withTranslations from "../../../../../hocs/withTranslations";
import withUserData from "../../../../../hocs/withUserData";
import matchSupportedLocale from "../../../../../lib/locale/matchSupportedLocale";

const getFallbackLocale = () => {
  const pathname = window?.location?.pathname;
  const match = pathname?.match(/\/([a-z]{2})(?:\/|$)/);

  return config.supportedLocales.includes(match?.[1]) ? match[1] : undefined;
};

function LanguageHelper({ applyLocale, userData, history, locale }) {
  const lang = userData?.lang;

  useEffect(() => {
    handleLanguageChange();
  }, [lang, history?.location?.pathname]);

  useEffect(() => {
    const fallbackLocale = getFallbackLocale();

    if (
      typeof lang === "undefined" &&
      typeof locale !== "undefined" &&
      typeof fallbackLocale !== "undefined" &&
      locale !== fallbackLocale
    ) {
      applyLocale(fallbackLocale);
    }
  }, [applyLocale, lang, locale]);

  const handleLanguageChange = () => {
    if (typeof applyLocale !== "function" || typeof lang !== "string") return;

    const pathname = window?.location?.pathname;

    if (typeof pathname === "undefined") return;

    const parsedLang =
      matchSupportedLocale(lang) || config.defaultLocale;
    const containCurrentLang = new RegExp(`/${parsedLang}/`, "g");

    if (containCurrentLang.test(pathname)) return;

    const newUrl = UrlProvider.replaceLocaleFromUrl(pathname, parsedLang);

    applyLocale(parsedLang);
    history.push({
      pathname: newUrl,
      search: history.location.search,
      hash: history.location.hash
    });
  };

  return null;
}

export default compose(
  withTranslations,
  withRouter,
  withUserData
)(LanguageHelper);
